<div class="flex flex-col gap-2 max-md:flex-col">
  <div class="flex items-center gap-3">
    <h3 class="font-medium" tuiTitle>{{ title }}</h3>
    @if (counterLabel) {
      <span appearance="info" tuiBadge>{{ counterLabel }}</span>
    }
  </div>
  <pxc-user-state-count [userCountByAdminState]="userCountByAdminState" />
</div>
<pxc-action-buttons [actionButtons]="actionButtonsGroups" [actions]="actions" />
